import type { WorldMeta } from "../registry";

export const meta: WorldMeta = {
  id: "FW-02",
  name: "Queuewell",
  slug: "queuewell",
  title: "Queuewell — a Fable World: SaaS waitlist page",
  description:
    "An original waitlist page designed by Fable: typography that queues, amber on near-black, a place in line you can watch move."
};

export default meta;
